<template>
  <ul class="j-auto-complete" id="j-auto-complete">
    <li class="ac-item" v-for="(d, i) in datas" :key="i" :class="{current: current === i}">
      <a :href="basePdf + d.pdf" target="_blank">{{ d.name }}</a>
    </li>
  </ul>
</template>
<script>
  export default {
    props: ['datas', 'current'],
    data () {
      return {
        basePdf: '/static/pdf/'
      }
    },
    computed: {
      finalData () {
        if (!this.codes || !this.codes.length) {
          return this.datas
        }
        if (!this.datas || !this.datas.length) {
          return this.codes
        }
        let a = []
        let b = []
        const codes = this.codes.filter(({ goodid, goodno }) => goodid !== goodno)
        const l1 = this.datas.length
        const l2 = codes.length
        if (l1 < 4) {
          a = [...this.datas]
          b = codes.slice(0, 8 - l1)
        } else if (l2 < 4) {
          a = this.datas.slice(0, 8 - l2)
          b = [...codes]
        } else {
          a = this.datas.slice(0, 4)
          b = codes.slice(0, 4)
        }
        return [...a, ...b]
      }
    },
    methods: {
      handleClickClose () {
        this.$emit('close')
      }
    }
  }
</script>
<style type="text/scss" lang="scss" rel="stylesheet/scss">
  @mixin active {
    color: #c77405;
    border: 1px solid #fbcb09;
    font-weight: bold;
    box-sizing: border-box;
    background-color: #fef9e2;
  }
  #j-auto-complete {
    position: absolute;
    cursor: default;
    font-size: 1rem;
    color: #333;
    border: 1px solid #ddd;
    background-color: #f9f9f9;
    z-index: 1000;
    padding-top: 10px;
    width: 450px;
    left: 0;
    .ac-item {
      position: relative;
      margin: 0;
      padding: 3px 1em 3px 1px;
      cursor: pointer;
      min-height: 0;
      text-align: left;
      width: 100%;
      a {
        color: #333333;
        font-size: 0.9rem;
        padding: 3px 10px;
      }
    }
    .title {
      padding: 3px 8px;
      margin: 4px 0;
      font-weight: 700;
    }
    .ac-category {
      font-weight: bold;
      padding: 0.2em 0.4em;
      margin: 0.8em 0 0.2em;
      line-height: 1.5;
      text-align: left;
    }
  }
  @media screen and (min-width: 768px) {
    .ac-item:hover,
    .ac-item.current {
      @include active;
    }
  }
  @media screen and (max-width: 767px) {
    #j-auto-complete {
      width: calc(100% - 20px);
      left: 10px;
      .ac-item {
        display: block;
        -webkit-tap-highlight-color: #c77405;
        width: 88%;
        padding-right: 5px;
      }
      .close-search {
        padding: 0;
        text-align: right;
        height: 0;
        a {
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-right: 10px;
          position: relative;
          &::before,
          &::after {
            content: '';
            position: absolute;
            width: 18px;
            height: 2px;
            background-color: #333;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            margin: auto;
            transform-origin: 50% 50%;
            transform: rotate(45deg);
          }
          &::after {
            transform: rotate(-45deg);
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/header/AutoComplete.vue